import { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _, { noop } from 'lodash'

import { isDockSectionOpenSelector, openSectionSelector } from './selectors'
import { DockSection, ScrollDockSection } from './types'
import { mediaActions } from './sections/media'
import { storagesActions } from './sections/storages'
import { versionsActions } from './sections/versions'
import { commentsActions } from './sections/comments'
import { scrollTopPxSelector as scrollTopPxForMediaSelector } from './sections/media/selectors'
import { scrollTopPxSelector as scrollTopPxForStoragesSelector } from './sections/storages/selectors'
import { scrollTopPxSelector as scrollTopPxForVersionsSelector } from './sections/versions/selectors'
import { scrollTopPxSelector as scrollTopPxForCommentsSelector } from './sections/comments/selectors'
import { RootState } from '../../reducers'

export function useIsDockOpen(): boolean {
  return !!useSelector(openSectionSelector)
}

export function useOpenDockSectionName(): DockSection | undefined {
  return useSelector(openSectionSelector)
}

export function useIsDockSectionOpen(section: DockSection): boolean {
  return useSelector(isDockSectionOpenSelector(section))
}

export function useScrollToTopForDockSection(dockSection: ScrollDockSection): number {
  const selectors: Record<ScrollDockSection, (state: RootState) => number> = {
    MEDIA: scrollTopPxForMediaSelector,
    STORAGES: scrollTopPxForStoragesSelector,
    VERSIONS: scrollTopPxForVersionsSelector,
    COMMENTS: scrollTopPxForCommentsSelector
  }

  return useSelector(selectors[dockSection]!)
}

export function useSetScrollTopForDockSection(dockSection: ScrollDockSection) {
  const dispatch = useDispatch()

  return useMemo(() => {
    const setters: Record<ScrollDockSection, (scrollTopPx: number) => void> = {
      MEDIA: (scrollTopPx: number) => dispatch(mediaActions.setScrollTopPx(scrollTopPx)),
      STORAGES: (scrollTopPx: number) => dispatch(storagesActions.setScrollTopPx(scrollTopPx)),
      VERSIONS: (scrollTopPx: number) => dispatch(versionsActions.setScrollTopPx(scrollTopPx)),
      COMMENTS: (scrollTopPx: number) => dispatch(commentsActions.setScrollTopPx(scrollTopPx))
    }

    return _.debounce(setters[dockSection] || noop, 200)
  }, [dispatch, dockSection])
}
